import React from "react";
import { useNavigate } from "react-router-dom";
import promoIcon from "../../assets/landing/Promo1.svg";
import LanguageToggle from "../Landing/LanguageToggle";

import SupremeLogo from "../Common/SupremeLogo";

export default function LandingHeader({ translations, onPromoOpen }) {
  const navigate = useNavigate();

  return (
    <div className="relative z-10 mt-5 w-full max-w-[1438px] h-[100px] mx-auto px-4 sm:px-6 md:px-10 lg:px-[50px] flex flex-col sm:flex-row items-center justify-between gap-8">
      {/* Logo */}
      <div translate="no" className="flex items-center w-[232.87px] h-[60.27px] hover:cursor-pointer notranslate" onClick={() => navigate("/")}>
        <SupremeLogo />
      </div>

      {/* Buttons */}
      <div className="grid grid-cols-2 xs:gap-x-0 gap-x-5 gap-y-4 xs:flex xs:flex-row items-center justify-center">
        {/* Promo Button */}
        <button
          type="button"
          onClick={onPromoOpen}
          className="flex items-center justify-center gap-2 cursor-pointer 
            bg-[#000101] font-public-sans text-white font-medium rounded-[100px] relative z-10  transition-all duration-300 
            px-3 py-1 
            w-full xs:w-[120px] h-[37.3px] 
            sm:w-[150px] sm:h-[43.3px] 
            md:w-[181.3px] md:h-[49.3px] 
            mr-5 border-2 border-transparent bg-gradient-to-b from-[#52FAF0] via-[#36BAE0] to-[#197AD0] bg-origin-border"
          style={{
            backgroundImage:
              "linear-gradient(#000101, #000101), linear-gradient(180deg, #52FAF0 1.84%, #36BAE0 21.65%, #197AD0 106.4%)",
            backgroundClip: "padding-box, border-box",
            backgroundOrigin: "border-box",
            boxShadow: "0px 11px 117.9px 0px #0000008C",
          }}
        >
          <img
            src={promoIcon}
            alt="Promo"
            className="object-contain w-4 h-4 md:w-[25.3px] md:h-[25.3px]"
          />
          <span className="text-[14px] sm:text-[17px] md:text-[20px] uppercase font-medium leading-[100%] text-[#FFFFFF]">
            {translations?.landingpage?.promoButton || "Promo"}
          </span>
        </button>

        {/* Login Button */}
        <button
          type="button"
          onClick={() => navigate("/signin")}
          className="bg-[#000101] font-public-sans text-white font-medium rounded-[100px] relative z-10 gap-2 cursor-pointer transition-all duration-300 
            px-3 py-1 
            w-auto h-[37px] 
            sm:w-auto sm:h-[43px] 
            md:w-auto md:h-[48px] 
            mr-0 xs:mr-5 border-2 border-transparent bg-gradient-to-b from-[#52FAF0] via-[#36BAE0] to-[#197AD0] bg-origin-border"
          style={{
            backgroundImage:
              "linear-gradient(#000101, #000101), linear-gradient(180deg, #52FAF0 1.84%, #36BAE0 21.65%, #197AD0 106.4%)",
            backgroundClip: "padding-box, border-box",
            backgroundOrigin: "border-box",
            boxShadow: "0px 11px 117.9px 0px #0000008C",
          }}
        >
          <span
            className="text-[14px] sm:text-[17px] md:text-[20px] uppercase text-white font-medium lg:px-[24px]
              bg-gradient-to-b from-[#52FAF0] via-[#36BAE0] to-[#197AD0] 
              bg-clip-text text-transparent"
          >
            {translations?.landingpage?.loginButton || "Login"}
          </span>
        </button>
        <div className="max-[375px]:col-span-2 max-[375px]:w-full max-[375px]:flex max-[375px]:justify-center">
          <LanguageToggle />
        </div>
      </div>
    </div>
  );
}
